import { render, staticRenderFns } from "./ManagerDetails.vue?vue&type=template&id=2e208231&scoped=true&"
import script from "./ManagerDetails.vue?vue&type=script&lang=js&"
export * from "./ManagerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDetails.vue?vue&type=style&index=0&id=2e208231&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e208231",
  null
  
)

export default component.exports